"use client";

import * as React from "react";

/**
 * Chữ tự co cho vừa khung: bắt đầu ở cỡ lớn theo chiều cao hộp, rồi thu nhỏ dần
 * tới khi không còn tràn (cả chiều cao lẫn chiều ngang). Tự chạy lại khi hộp đổi
 * kích thước (vào/thoát toàn màn hình). Nhờ vậy câu hỏi/đáp án dài cũng không vỡ.
 */
export function FitText({ text, maxPx = 44, minPx = 12 }: { text: string; maxPx?: number; minPx?: number }) {
  const ref = React.useRef<HTMLDivElement>(null);
  const fit = React.useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const start = Math.max(minPx, Math.min(maxPx, Math.round(el.clientHeight * 0.72)));
    let s = start;
    el.style.fontSize = `${s}px`;
    let guard = 0;
    while (guard++ < 90 && s > minPx && (el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1)) {
      s -= 1;
      el.style.fontSize = `${s}px`;
    }
  }, [maxPx, minPx]);
  React.useLayoutEffect(() => {
    fit();
  }, [text, fit]);
  React.useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => fit());
    ro.observe(el);
    return () => ro.disconnect();
  }, [fit]);
  return (
    <div ref={ref} className="flex h-full w-full items-center justify-center overflow-hidden break-words text-center leading-tight">
      {text}
    </div>
  );
}
